import { ref, toRef, computed } from 'vue'
import { useArtistHistory } from './useArtistHistory'
import { useVenueHistory } from './useVenueHistory'

const URLS = {
    icons: {
        'American Express': '/images/icons/payment-details/cc-amex.svg',
        Visa: '/images/icons/payment-details/cc-visa.svg',
        MasterCard: '/images/icons/payment-details/cc-mastercard.svg',
        Discover: '/images/icons/payment-details/cc-discover.svg',
        UnionPay: '/images/icons/payment-details/UnionPay.svg',
        DinaCard: '/images/icons/payment-details/DinaCard.svg',
        'Diners Club': '/images/icons/payment-details/DinersClub.svg',
        BCCard: '/images/icons/payment-details/BCCard.svg',
        JCB: '/images/icons/payment-details/JSB.svg',
        others: '/images/icons/payment-details/cc-regular.svg',
        bank: '/images/icons/bank.svg',
        sortUpEmpty: '/images/icons/sort-up-empty.svg',
        sortUpFilled: '/images/icons/sort-up-filled.svg',
        sortDownEmpty: '/images/icons/sort-down-empty.svg',
        sortDownFilled: '/images/icons/sort-down-filled.svg',
        rightArrow: '/images/icons/next.svg',
        leftArrow: '/images/icons/prev.svg'
    },
    redirect: {
        event: '/event/show',
        stripeProfile: '/profile/stripe-profile'
    }
}
export const useBillingHistory = (props) => {
    const role = toRef(props, 'role')
    const userId = toRef(props, 'user')
    const columns = ref([])
    const data = ref([])
    const load = ref(false)
    const { artistBillingColumnDef, artistHistory } = useArtistHistory(userId, load)
    const { venueBillingColumnDef, venueHistory } = useVenueHistory(userId, load)

    ;(() => {
        if (!role.value) {
            throw new Error('need to pass in role: string')
        }

        _initBillingHistory(role.value)
    })()

    function _initBillingHistory(role) {
        switch (role) {
            case 'artist':
                columns.value = artistBillingColumnDef.value
                data.value = artistHistory
                break
            case 'venue':
                columns.value = venueBillingColumnDef.value
                data.value = venueHistory
                break
            default:
                break
        }
        // initialize column, and data, based on role
        // then update ArtistBillingHistory and VenueBillingHistory component to use column and data
    }

    const pillColor = computed(() => {
        return (status) => {
            switch (status.toLowerCase()) {
                case 'pending':
                    return { background: '#8B8B8B' }
                case 'complete':
                    return { background: '#198754' }
                case 'need bank details':
                    return { background: '#FFC107' }
                case 'error':
                    return { background: '#E23453' }
                default:
                    return {}
            }
        }
    })

    const amountColor = computed(() => {
        return (type, status) => {
            switch (status.toLowerCase()) {
                case 'pending':
                case 'complete': {
                    return type !== 'Refund' ? { color: '#CDEB09' } : { color: '#BA87FF' }
                }
                case 'need bank details':
                case 'error':
                    return { color: '#464646' }
                default:
                    return {}
            }
        }
    })
    const showStatusDetail = computed(() => {
        return (detail) => {
            if (detail.status.toLowerCase() === 'need bank details') {
                return {
                    show: true,
                    value: 'Provide Details',
                    class: 'provide-details',
                    func: true,
                    call: () => window.open(URLS.redirect.stripeProfile, '_blank')
                }
            } else if (
                (detail.status.toLowerCase() === 'complete' || detail.status.toLowerCase() === 'pending') &&
                detail.clear_date
            ) {
                return {
                    show: true,
                    value: detail.clear_date,
                    class: 'clear-date',
                    func: false,
                    call: null
                }
            } else {
                return {
                    show: false,
                    value: null,
                    class: null,
                    func: null,
                    call: null
                }
            }
        }
    })

    function sort(header, headers, sortBy) {
        _resetSort(headers, header)
        switch (header.actions.sortDirection) {
            case 'off':
                header.actions.sortDirection = 'asc'
                break
            case 'asc':
                header.actions.sortDirection = 'desc'
                break
            case 'desc':
                header.actions.sortDirection = 'asc'
                break
            case null:
            default:
                break
        }

        sortBy(header.accessor, header.actions.sortDirection, {
            subAccessor: header.accessor === 'status' ? 'status' : null
        })
    }

    function _resetSort(headers, header) {
        headers.forEach((h) => {
            if (!h.actions.sortDirection) return

            if (h !== header) {
                h.actions.sortDirection = 'off'
            }
        })
    }
    return {
        URLS,
        columns,
        data,
        pillColor,
        amountColor,
        showStatusDetail,

        sort
    }
}
